var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.value.addressName))]),_c('div',[_vm._v(_vm._s(_vm.value.street)+" "+_vm._s(_vm.value.streetNo))]),_c('div',[_vm._v(_vm._s(_vm.value.zipCode)+" "+_vm._s(_vm.value.postSite))]),_c('div',[_vm._v(_vm._s(_vm.country !== undefined && _vm.country != null ? _vm.country.native : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }